export default "__VITE_ASSET__sHTKeoSV__"